import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Badge, Spinner } from "react-bootstrap";

const ExperienciaProveedor = ({
  fechaInicioActividad,
  setFechaInicioActividad,
  fechaCalificacion,
  setFechaCalificacion,
  calificacionId,
  onExperienciaGuardada
}) => {
  const [calculos, setCalculos] = useState({
    añosExperienciaEvaluacion: 0,
    añosExperiencia: 0,
    calificacionExperiencia: 0
  });

  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [datosCargados, setDatosCargados] = useState(false);

  const rangosCalificacion = [
    { max: 1, puntaje: 50 },
    { max: 2, puntaje: 75 },
    { max: 999, puntaje: 100 }
  ];

  useEffect(() => {
    cargarDatosExistentes();
  }, [calificacionId]);

  useEffect(() => {
    if (fechaInicioActividad && fechaCalificacion) {
      calcularExperiencia();
    }
  }, [fechaInicioActividad, fechaCalificacion]);

  const cargarDatosExistentes = async () => {
    if (!calificacionId) {
      setCargando(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `https://apiprov.conduto.com.ec/api/calificaciones/${calificacionId}/experiencia`,
        {
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.existe && data.data) {
          const exp = data.data;
          setFechaInicioActividad(exp.fecha_inicio_actividad);
          setFechaCalificacion(exp.fecha_calificacion);
          setCalculos({
            añosExperienciaEvaluacion: parseFloat(exp.años_experiencia_evaluacion) || 0,
            añosExperiencia: parseFloat(exp.años_experiencia_total) || 0,
            calificacionExperiencia: parseFloat(exp.calificacion_experiencia) || 0
          });
          setDatosCargados(true);
          if (onExperienciaGuardada) onExperienciaGuardada(true);
        }
      }
    } catch (error) {
      console.error("Error cargando experiencia:", error);
    } finally {
      setCargando(false);
    }
  };

  const calcularExperiencia = async () => {
    if (!fechaInicioActividad || !fechaCalificacion) {
      setCalculos({
        añosExperienciaEvaluacion: 0,
        añosExperiencia: 0,
        calificacionExperiencia: 0
      });
      return;
    }

    const fechaInicio = new Date(fechaInicioActividad);
    const fechaCal = new Date(fechaCalificacion);
    const hoy = new Date();

    // Calcular años de experiencia (conversión aproximada: 360 días = 1 año)
    const añosEvaluacion = (fechaCal - fechaInicio) / (1000 * 3600 * 24 * 360);
    const añosTotal = (hoy - fechaInicio) / (1000 * 3600 * 24 * 360);

    let calificacion = 0;
    for (const rango of rangosCalificacion) {
      if (añosEvaluacion <= rango.max) {
        calificacion = rango.puntaje;
        break;
      }
    }

    const nuevosCalculos = {
      añosExperienciaEvaluacion: añosEvaluacion,
      añosExperiencia: añosTotal,
      calificacionExperiencia: calificacion
    };

    setCalculos(nuevosCalculos);

    // Solo guardar si hay una calificaciónId y los datos son válidos
    if (calificacionId && fechaInicioActividad && fechaCalificacion) {
      await guardarEnBaseDatos(nuevosCalculos);
    }
  };

  const guardarEnBaseDatos = async (dataCalc) => {
    if (!calificacionId || !fechaInicioActividad || !fechaCalificacion) return;

    try {
      setGuardando(true);
      const token = localStorage.getItem("token");

      const payload = {
        fecha_inicio_actividad: fechaInicioActividad,
        fecha_calificacion: fechaCalificacion,
        años_experiencia_evaluacion: dataCalc.añosExperienciaEvaluacion,
        años_experiencia_total: dataCalc.añosExperiencia,
        calificacion_experiencia: dataCalc.calificacionExperiencia
      };

      const response = await fetch(
        `https://apiprov.conduto.com.ec/api/calificaciones/${calificacionId}/experiencia`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          credentials: "include",
          body: JSON.stringify(payload)
        }
      );

      if (response.ok) {
        if (onExperienciaGuardada) onExperienciaGuardada(true);
      } else {
        console.error("Error al guardar experiencia");
        if (onExperienciaGuardada) onExperienciaGuardada(false);
      }
    } catch (error) {
      console.error("Error guardando experiencia:", error);
      if (onExperienciaGuardada) onExperienciaGuardada(false);
    } finally {
      setGuardando(false);
    }
  };

  const getBadgeVariant = (calificacion) => {
    if (calificacion >= 80) return "success";
    if (calificacion >= 60) return "warning";
    return "danger";
  };

  const handleFechaInicioChange = (e) => {
    setFechaInicioActividad(e.target.value);
    setDatosCargados(false);
    if (onExperienciaGuardada) onExperienciaGuardada(false);
  };

  const handleFechaCalificacionChange = (e) => {
    setFechaCalificacion(e.target.value);
    setDatosCargados(false);
    if (onExperienciaGuardada) onExperienciaGuardada(false);
  };

  if (cargando) {
    return (
      <Card className="mb-4">
        <Card.Body className="text-center">
          <Spinner animation="border" />
          <p className="mt-2">Cargando datos de experiencia...</p>
        </Card.Body>
      </Card>
    );
  }

  const ambasFechasCompletadas = fechaInicioActividad && fechaCalificacion;

  return (
    <Card className="mb-4">
      <Card.Header className="d-flex justify-content-between align-items-center bg-light">
        <h5 className="mb-0">Experiencia del Proveedor</h5>
        {guardando && <Spinner animation="border" size="sm" />}
      </Card.Header>

      <Card.Body>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                <strong>Fecha inicio actividad:</strong> <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={fechaInicioActividad || ''}
                onChange={handleFechaInicioChange}
                required
                isInvalid={!fechaInicioActividad && fechaCalificacion}
              />
              <Form.Control.Feedback type="invalid">
                La fecha de inicio es requerida
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>
                <strong>Fecha de calificación:</strong> <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={fechaCalificacion || ''}
                onChange={handleFechaCalificacionChange}
                required
                isInvalid={!fechaCalificacion && fechaInicioActividad}
              />
              <Form.Control.Feedback type="invalid">
                La fecha de calificación es requerida
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        {ambasFechasCompletadas && (
          <Row className="g-3 mt-4">
            <Col md={4}>
              <Form.Label>
                <strong>Años de experiencia en la evaluación</strong>
              </Form.Label>
              <Form.Control
                readOnly
                className="bg-light text-center fw-bold"
                value={calculos.añosExperienciaEvaluacion.toFixed(2)}
              />
            </Col>

            <Col md={4}>
              <Form.Label>
                <strong>Años de experiencia total</strong>
              </Form.Label>
              <Form.Control
                readOnly
                className="bg-light text-center fw-bold"
                value={calculos.añosExperiencia.toFixed(2)}
              />
            </Col>

            <Col md={4}>
              <Form.Label>
                <strong>Calificación por experiencia</strong>
              </Form.Label>
              <div>
                <Badge
                  bg={getBadgeVariant(calculos.calificacionExperiencia)}
                  className="w-100 p-2 fs-6"
                >
                  {calculos.calificacionExperiencia}%
                </Badge>
              </div>
            </Col>
          </Row>
        )}

        {!ambasFechasCompletadas && (
          <div className="text-center text-muted mt-3">
            <small>Complete ambas fechas para calcular la experiencia</small>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ExperienciaProveedor;